import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import env from '@maui-mf/env'
import {
  HeaderMenu,
  HeaderMenuItem,
} from '@maui/elements'
import { UpgradeIconPill } from '@maui/freemium'
import useNamedRoute from '../hooks/useNamedRoute'
import { useAuthContext } from '../AuthContext'

export const ExploreMenu = () => {
  const actorsRoute = useNamedRoute('actorExplore')
  const campaignsRoute = useNamedRoute('campaignExplore')
  const malwareRoute = useNamedRoute('malwareExplore')
  const mitreAttackRoute = useNamedRoute('mitreAttackExplore')
  const vulnerabilityRoute = useNamedRoute('vulnerabilityExplore')
  const { hasVulnAccess, hasFusionAccess, isFreemium } = useAuthContext()

  const location = useLocation()
  const active = !!location.pathname.match(/^\/(actors|malware|mitreattack|cve)/)
  const hasCampaignFeature = env?.FEATURE_CAMPAIGN === 1
  const hasVulnOrFusion = hasVulnAccess || hasFusionAccess
  const routeWithFreemium = (route, condition = isFreemium) => condition ? '/upgrade' : route

  return (
    <HeaderMenu
      label="Explore"
      active={active}
    >
      <HeaderMenuItem as={NavLink} to={actorsRoute}>Actors</HeaderMenuItem>
      {hasCampaignFeature && <HeaderMenuItem as={NavLink} to={routeWithFreemium(campaignsRoute)}>
        Campaigns
        {isFreemium && <UpgradeIconPill variant="icon" />}
      </HeaderMenuItem>}
      <HeaderMenuItem as={NavLink} to={malwareRoute}>Malware and Tools</HeaderMenuItem>
      <HeaderMenuItem as={NavLink} to={mitreAttackRoute}>MITRE ATT&CK</HeaderMenuItem>
      <HeaderMenuItem as={NavLink} to={routeWithFreemium(vulnerabilityRoute, !hasVulnOrFusion)}>
        Vulnerabilities
        {!hasVulnOrFusion && <UpgradeIconPill variant="icon" />}
      </HeaderMenuItem>
    </HeaderMenu>
  )
}
